<template>
  <div class="custom-container">
    <div class="wrapper">
      <h1>Mesafeli Satış Sözleşmesi</h1>
      <p><strong>MADDE 1- TARAFLAR</strong></p>

      <p>SATICIYA İLİŞKİN BİLGİLER</p>

      <p>Ticari Ünvan: FXY Bilgi Teknolojileri Ve Dijital Pazarlama Ltd.Şti<br>
        Adres: Sakarya Üniversitesi Teknoloji Geliştirme Bölgesi (TEKNOKENT)</p>

      <p>Esentepe Mah. Akademi Yolu Sok.A blok B07 Serdivan / Sakarya<br>
        Web adresi:&nbsp;<a href="http://www.yurtlarburada.com">www.yurtlarburada.com</a><br>
        E-posta adresi : destek@ yurtlarburada.com<br>
        Telefon: 0264 281 65 55<br>
        Telefon: 0541 212 98 78<br>
        &nbsp;</p>

      <p>ALICIYA İLİŞKİN BİLGİLER</p>

      <p>Adı Soyadı / Ünvanı:&nbsp;.............<br>
        Teslimat Adresi:&nbsp;...................<br>
        Telefon:&nbsp;..............................<br>
        E-posta:&nbsp;.............................</p>

      <p>&nbsp;</p>

      <p><strong>MADDE 2- KONU</strong></p>

      <p>İşbu sözleşmenin&nbsp;konusu ALICI’nın SATICI'ya ait&nbsp;<a href="http://www.yurtlarburada.com">www.yurtlarburada.com</a>&nbsp;internet sitesinden elektronik ortamda sipariş verdiği, aşağıda nitelik ve satış fiyatı belirtilen ürün ya da ürünlerin satışı ve teslimi ile ilgili olarak 6502 sayılı Tüketicilerin Korunması Hakkında Kanun ve 6 Mart 2011 tarihli ve 27866 sayılı Resmi Gazetede yayınlanan Mesafeli Sözleşmelere Dair Yönetmelik hükümleri gereğince tarafların hak ve yükümlülüklerinin saptanmasıdır.<br>
        &nbsp;</p>

      <p><strong>MADDE 3- SÖZLEŞME KONUSU ÜRÜN</strong></p>

      <p>3.1. Ürünlerin Cinsi ve türü, Miktarı, Marka/Modeli, Rengi, Birim Fiyat ve Vergiler&nbsp;aşağıda belirtildiği gibidir.</p>

      <p>&nbsp;</p>

      <table border="0" cellpadding="0" cellspacing="0" style="width:600px;" width="600">
        <tbody>
        <tr>
          <td>
            <p align="center"><strong>Adı</strong></p>
          </td>
          <td>
            <p align="center"><strong>Fiyatı</strong></p>
          </td>
          <td>
            <p align="center"><strong>Miktar</strong></p>
          </td>
          <td>
            <p align="right"><strong>Toplam</strong></p>
          </td>
        </tr>
        <tr>
          <td>
            <p align="center">...........................</p>
          </td>
          <td>
            <p align="center">XXX&nbsp;₺</p>
          </td>
          <td>
            <p align="center">X</p>
          </td>
          <td>
            <p align="right">XXX&nbsp;₺</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>&nbsp;</p>
          </td>
          <td colspan="2">
            <p><strong>Ara Toplam:</strong></p>
          </td>
          <td>
            <p><strong>XXX&nbsp;₺</strong></p>
          </td>
        </tr>
        <tr>
          <td>
            <p>&nbsp;</p>
          </td>
          <td colspan="2">
            <p>&nbsp;</p>
          </td>
          <td>
            <p>&nbsp;</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>&nbsp;</p>
          </td>
          <td colspan="2">
            <p><strong>Kargo :</strong></p>
          </td>
          <td>
            <p><strong>XXX&nbsp;₺</strong></p>
          </td>
        </tr>
        <tr>
          <td>
            <p>&nbsp;</p>
          </td>
          <td colspan="2">
            <p><strong>KDV %18:</strong></p>
          </td>
          <td>
            <p><strong>XXX&nbsp;₺</strong></p>
          </td>
        </tr>
        <tr>
          <td>
            <p align="right">&nbsp;</p>
          </td>
          <td colspan="2">
            <p align="right"><strong>Sipariş Toplamı :</strong></p>
          </td>
          <td>
            <p align="right"><strong>XXX&nbsp;₺</strong></p>
          </td>
        </tr>
        </tbody>
      </table>

      <p>&nbsp;</p>

      <p>3.2. Ödeme Şekli:</p>

      <p>&nbsp;</p>

      <p>Yukarıdaki bankanıza iletilecek sipariş toplamının kaç taksitle ödeneceği bilgisi bulunmaktadır.</p>

      <p>Bankanız kampanyalar düzenleyerek sizin seçtiğiniz taksit adedinin daha üstünde bir taksit adedi uygulayabilir, taksit öteleme gibi hizmetler sunulabilir. Bu tür kampanyalar bankanızın inisiyatifindedir ve şirketimizin bilgisi dâhilinde olması durumunda sayfalarımızda kampanyalar hakkında bilgi verilmektedir.</p>

      <p>Kredi kartınızın hesap kesim tarihinden itibaren sipariş toplamı taksit adedine bölünerek kredi kartı özetinize bankanız tarafından yansıtılacaktır. Banka taksit tutarlarını küsurat farklarını dikkate alarak aylara eşit olarak dağıtmayabilir. Detaylı ödeme planınızın oluşturulması bankanız inisiyatifindedir.</p>

      <p>&nbsp;</p>

      <p>3.3- Diğer yandan vadeli satışların sadece Bankalara ait kredi kartları ile yapılması nedeniyle, alıcı, ilgili faiz oranlarını ve temerrüt faizi ile ilgili bilgileri bankasından ayrıca teyit edeceğini, yürürlükte bulunan mevzuat hükümleri gereğince faiz ve temerrüt faizi ile ilgili hükümlerin Banka ve alıcı arasındaki kredi kartı sözleşmesi kapsamında uygulanacağını kabul, beyan ve taahhüt eder.</p>

      <p>&nbsp;</p>

      <p>3.4-&nbsp;Müşteri (son kullanıcı), ödeme yöntemine, üyeliğine ve siparişine ilişkin bilgilerin, ödemenin gerçekleştirilebilmesi ve ödeme usulsüzlüklerinin önlenmesi, araştırılması ve tespit edilmesini temin amacıyla iyzico Ödeme Hizmetleri A.Ş.’ye aktarılmasına ve iyzico tarafından&nbsp;<a href="https://www.iyzico.com/gizlilik-politikasi/" target="_blank">https://www.iyzico.com/gizlilik-politikasi/&nbsp;</a>adresindeki Gizlilik Politikası’nın en güncel halinde açıklandığı şekilde işlenmesine ve saklanmasına rıza göstermektedir.</p>

      <p>&nbsp;</p>

      <p><strong>MADDE 4- MAL VE HİZMETİN TÜM VERGİLER DAHİL TESLİM FİYATI</strong></p>

      <p>&nbsp;Madde 3'te "Sipariş Toplamı" olarak verilen tutardır.</p>

      <p>&nbsp;</p>

      <p><strong>MADDE 5 - CAYMA HAKKI</strong></p>

      <p><strong>ALICI, Sözleşme konusu ürünün kendisine veya gösterdiği adresteki kişi/kuruluşa tesliminden itibaren 3 gün içinde hiçbir sebep göstermek zorunda olmaksızın cayma hakkına sahiptir.</strong></p>

      <p><strong>Cayma hakkının kullanılması için 3 günlük süre içinde SATICI'ya faks, telefon veya elektronik posta ile bildirimde bulunulması ve ürünün 6. madde hükümleri çerçevesinde ve işbu Sözleşmenin ayrılmaz parçası olan ve&nbsp;<a href="http://www.yurtlarburada.com">www.yurtlarburada.com</a> &nbsp;internet sitesinde yayınlanmış olan önbilgiler gereğince verilen hizmetler SATICI tarafından tekrar satışa arz edilebilir nitelikte olması şarttır. Bu hakkın kullanılması halinde,</strong></p>

      <p><strong>a) 3. kişiye veya ALICI’ya teslim edilen ürünün faturası, (İade edilmek istenen ürünün faturası kurumsal ise, iade ederken kurumun düzenlemiş olduğu iade faturası ile birlikte gönderilmesi gerekmektedir. Faturası kurumlar adına düzenlenen sipariş iadeleri İADE FATURASI kesilmediği takdirde tamamlanamayacaktır)</strong></p>

      <p><strong>b)www.yurtlarburada.com&nbsp;internet sitesi iletişim sayfası üzerinden İade Talebi oluşturulması,</strong></p>

      <p><strong>c) Bu belgelerin SATICI’ya ulaşmasını takip eden 30 gün içinde ürün bedeli ALICI'ya iade edilir . </strong></p>

      <p>&nbsp;</p>

      <p><strong>Ürün SATICI’ya iade edilirken, ürünün teslimi sırasında ALICI’ya ibraz edilmiş olan orijinal faturanın da iade edilmesi gerekmekte olup faturanın ürünle birlikte SATICI’ya gönderilmemesi durumunda ALICI’ya KDV ve varsa diğer yasal yükümlülükler iade edilemez. Ürünle beraber iade edilecek olan faturanın üzerine de "iade faturasıdır" ibaresi yazılıp ALICI tarafından imzalanacaktır.</strong></p>

      <p>&nbsp;</p>

      <p>MADDE 6 - GENEL HÜKÜMLER</p>

      <p><strong>6.1</strong>&nbsp;ALICI,&nbsp;<a href="http://www.yurtlarburada.com">www.yurtlarburada.com</a>&nbsp;internet sitesinde Sözleşme konusu ürünün temel nitelikleri, tüm vergiler dahil satış fiyatı ve ödeme şekli ile teslimata ve bunun masraflarının ALICI tarafından karşılanacağına, teslimatın gerçekleştirileceği süreye ve SATICI’nın tam ticari unvanı, açık adresi ve iletişim bilgilerine ilişkin ön bilgileri okuyup doğru ve eksiksiz bilgi sahibi olduğunu ve elektronik ortamda gerekli teyidi verdiğini beyan eder.&nbsp;<a href="http://www.eurometall.com.tr/">www.yurtlarburada.com</a>&nbsp;İnternet Sitesinde ödeme sayfasında yer alan ön bilgilendirme formu ve satışa ilişkin fatura işbu Sözleşmenin ayrılmaz parçalarıdır.</p>

      <p><strong>6.2</strong>&nbsp;SATICI tarafından daha önce imzalanmış bulunan iş bu iki nüsha Sözleşme ALICI tarafından elektronik ortamda okunup onaylanarak kabul edilmiş ve bir nüshası alıcının e-posta&nbsp;adresine gönderilecektir.</p>

      <p><strong>6.3</strong>&nbsp;Sözleşme konusu ürün, 3 günlük süreyi aşmamak koşulu ile her bir ürün için ALICI' ya hizmet esası olan reklam çalışmaları yapılarak <a href="http://www.yurtlarburada.com">www.yurtlarburada.com</a> üzerinden teslim edilir.</p>

      <p><strong>6.4</strong>&nbsp;Madde 3’te gösterilen teslimata ilişkin her türlü kargo ücreti ALICI tarafından karşılanacaktır. SATICI, web sitesinde, ilan ettiği rakamın üzerinde alışveriş yapanların veya kimi kampanyalarında teslimat ücretinin kendisince karşılanacağını beyan etmişse, teslimat masrafı SATICI tarafından karşılanır. Teslimat; stokun müsait olması ve mal bedelinin SATICI’nın hesabına geçmesinden sonra en kısa sürede yapılır.</p>

      <p><strong>6.5</strong>&nbsp;Sözleşme konusu ürün, ALICI'dan başka bir kişi/kuruluşa teslim edilecek ise, teslim edilecek kişi/kuruluşun teslimatı kabul etmemesinden SATICI sorumlu tutulamaz.</p>

      <p><strong>6.6 Kargo firmasının, hizmet karşılığı verilecek evrak veya dökümanların ALICI’ya teslimi aşamasında karşılaşacağı her türlü sorun nedeniyle, siparişi verilen ürünün ALICI'ya teslim edilememesinden dolayı SATICI sorumlu tutulamaz.</strong></p>

      <p><strong>6.7</strong>&nbsp;SATICI’NIN&nbsp;verilecek hizmet için yaptığı çalışmalar yayına verilir, ek istek ve özellikleri vermekle yükümlülük &nbsp;zorunluluğu bulunmamaktadır.</p>

      <p><strong>6.8.</strong>&nbsp;SATICI, Sözleşme konusu hizmetin alıcı ile yapılan hizmet sözleşmesinde yer aldığı gibi &nbsp;sağlam, eksiksiz, siparişte belirtilen niteliklere uygun ve varsa garanti belgeleri ve kullanım kılavuzları ile teslim edilmesinden sorumludur.</p>

      <p><strong>6.9. SATICI, haklı bir sebebe dayanmak şartıyla, Sözleşmeden doğan ifa yükümlülüğünün süresi dolmadan ALICI’ya eşit kalite ve fiyatta farklı bir ürün tedarik edebilir.</strong></p>

      <p><strong>6.10. SATICI, sipariş konusu ürün veya hizmetin yerine getirilmesinin imkânsızlaşması halinde Sözleşme konusu yükümlülüklerini yerine getiremezse, bu durumu, Sözleşmeden doğan ifa yükümlülüğünün süresi dolmadan tüketiciye bildirir ve ALICI’ya eşit kalite ve fiyatta farklı bir ürün tedarik edebilir.</strong></p>

      <p><strong>6.11. Sözleşme konusu ürünün teslimatı için işbu Sözleşmenin imzalı nüshasının SATICI'ya ulaştırılmış olması ve bedelinin ALICI'nın tercih ettiği ödeme şekli ile ödenmiş olması şarttır. Herhangi bir nedenle ürün bedeli ödenmez veya banka kayıtlarında iptal edilir ise, SATICI ürünün teslimi yükümlülüğünden kurtulmuş kabul edilir.</strong></p>

      <p><strong>6.12. Ürünün tesliminden sonra ALICI'ya ait kredi kartının ALICI'nın kusurundan kaynaklanmayan bir şekilde yetkisiz kişilerce haksız veya hukuka aykırı olarak kullanılması nedeni ile ilgili banka veya finans kuruluşun ürün bedelini SATICI'ya ödememesi halinde, ALICI'nın kendisine teslim edilmiş olması kaydıyla ürünün 3 gün içinde SATICI'ya gönderilmesi zorunludur. Bu takdirde nakliye giderleri ALICI'ya aittir.</strong></p>

      <p><strong>6.13</strong>&nbsp;SATICI mücbir sebepler veya nakliyeyi engelleyen hava muhalefeti, ulaşımın kesilmesi gibi olağanüstü durumlar nedeni ile Sözleşme konusu ürünü süresi içinde teslim edemez ise, durumu ALICI'ya bildirmekle yükümlüdür. Bu takdirde ALICI siparişin iptal edilmesini, Sözleşme konusu ürünün varsa emsali ile değiştirilmesini, ve/veya teslimat süresinin engelleyici durumun ortadan kalkmasına kadar ertelenmesi haklarından birini kullanabilir. ALICI'nın siparişi iptal etmesi halinde ödediği tutar 20 gün içinde kendisine nakden ve defaten ödenir.</p>

      <p>ALICI’nın kredi kartı ile yaptığı ödemelerde ise, ürün tutarı, siparişin ALICI tarafından iptal edilmesinden sonra 30 gün içerisinde ilgili bankaya iade edilir. Bu tutarın bankaya iadesinden sonra ALICI hesaplarına yansıması tamamen banka işlem süreci ile ilgili olup, SATICI’nın bu hususa ilişkin herhangi bir şekilde müdahalede bulunması mümkün olamamaktadır.</p>

      <p><strong>MADDE 7 - CAYMA HAKKI KULLANILAMAYACAK HİZMETLER</strong></p>

      <p><strong>Niteliği itibarıyla; REKLAM VE TANITIM HİZMETLERİ belli bir dönemi kapsar, barınma hizmeti veren yerler için KAYIT DÖNEMİNİNDEN sonra yada web sayfası hizmeti ise sayfa yayına verildikten sonra, tüketicinin istekleri veya açıkça onun özel&nbsp;ihtiyaçları doğrultusunda hazırlanan ürünler&nbsp;için cayma hakkı kullanılamaz</strong></p>

      <p><strong>Aşağıdaki ürünler için cayma hakkının kullanılabilmesi, hizmetin teslim edilmemiş ve yayına verilmemiş olması gerekir</strong></p>

      <p><strong>- Her türlü yazılım ve programlar</strong></p>

      <p><strong>- web sayfası hizmetleri</strong></p>

      <p><br>
        <br>
        <strong>MADDE 7 - BORÇLUNUN TEMERRÜDÜ</strong></p>

      <p>ALICI’nın temerrüde düşmesi halinde, ALICI, borcun gecikmeli ifasından dolayı SATICI’nın oluşan zarar ve ziyanını ödemeyi kabul eder. ALICI’nın temerrüdünün SATICI’nın kusurundan kaynaklandığı hallerde ALICI herhangi bir zarar ve ziyan talebini karşılamak mecburiyetinde olmayacaktır.&nbsp;</p>

      <p>MADDE 8 - YETKİLİ MAHKEME</p>

      <p>İşbu sözleşmenin uygulanmasında, Sanayi ve Ticaret Bakanlığı'nca ilan edilen değere kadar SAKARYA da bulunan Tüketici Hakem Heyetleri ile Tüketici Mahkemeleri yetkilidir.<br>
        &nbsp;</p>

      <p>Siparişin gerçekleşmesi durumunda ALICI işbu sözleşmenin tüm koşullarını kabul etmiş sayılır.<br>
        &nbsp;</p>

      <p>SATICI</p>

      <p>Yurtlarburada.com (FXY Bilgi Teknolojileri Ve Dijital Pazarlama</p>

      <p>ALICI</p>

      <p>..........................</p>

      <p>TARİH</p>

      <p>..........................</p>

      <p>&nbsp;</p>
      <p></p>
    </div>

  </div>

</template>

<script>
export default {
  name: 'user-contract'
}
</script>

<style lang="scss">
  @import "../assets/scss/components/user-contract";
</style>
